import CartPageContent from "src/layouts/CartPageContent";

const CartPage = () => <CartPageContent />;

export default CartPage;
